import {Component, Input} from '@angular/core';
import {ArticlePrice} from "../../models/article-price.model";
import {ArticlePriceService} from "../../services/article-price.service";

@Component(
    {
        selector: 'app-shared-article-price-total',
        templateUrl: './article-price-total.component.html'
    }
)
export class ArticlePriceTotalComponent {
    @Input() private values: {
        articlePrice?: ArticlePrice,
        quantity: number,
    };

    constructor(
        private articlePriceService: ArticlePriceService,
    ) {

    }

    get articlePrice() {
        return this.values.articlePrice;
    }

    get nettPriceInOrderingUnitOfMeasure() {
        return this.articlePriceService.getNettPriceInOrderingUnitOfMeasure(this.values.articlePrice, this.values.quantity);
    }

    get grossPriceInOrderingUnitOfMeasure() {
        return this.articlePriceService.getGrossPriceInOrderingUnitOfMeasure(this.values.articlePrice, this.values.quantity);
    }

    get quantity() {
        return this.values.quantity;
    }
}
